import React from 'react';
import ContentLoader, {IContentLoaderProps} from 'react-content-loader';

const defaultProps = {
    speed: 1,
    backgroundColor: "#f3f3f3",
    foregroundColor: "#ecebeb"
}

type LoadingType = 'list' | 'card';

const LoadingTypes: Record<LoadingType, React.FC<IContentLoaderProps>> = {
    list: (props) => (
        <ContentLoader
            {...props}
            viewBox="0 0 400 160"
        >
            <rect x="42" y="6" rx="4" ry="4" width="343" height="38"/>
            <rect y="6" rx="4" ry="4" width="35" height="38"/>
            <rect x="42" y="55" rx="4" ry="4" width="343" height="38"/>
            <rect y="55" rx="4" ry="4" width="35" height="38"/>
            <rect x="42" y="104" rx="4" ry="4" width="343" height="38"/>
            <rect y="104" rx="4" ry="4" width="35" height="38"/>
        </ContentLoader>
    ),
    card: (props) => (
        <ContentLoader
            {...props}
            viewBox="0 0 265 230">
            <rect y="15" rx="4" ry="4" width="350" height="25"/>
            <rect y="50" rx="2" ry="2" width="350" height="150"/>
            <rect y="230" rx="2" ry="2" width="170" height="20"/>
            <rect y="230" rx="2" ry="2" width="170" height="20"/>
        </ContentLoader>
    ),
};

interface MyLoadingComponentProps extends IContentLoaderProps {
    type: LoadingType;
}

const ContentLoading: React.FC<MyLoadingComponentProps> = ({type, ...props}) => {
    const LoadingComponent = LoadingTypes[type] || (() => <div>Carregando...</div>);
    return <LoadingComponent {...defaultProps} {...props} />;
};

export default ContentLoading;
